/**
 * @name UserSideBar
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Componente que gerencia a barra lateral do layout do usuário.
 * @package src/components/layouts/UserLayout/components/UserSideBar/UserSideBar.tsx
 **/

import { Box, Drawer } from '@mui/material';
import React from 'react';
import useThemeContext from '../../../../../themes/hooks/useThemeContext';
import DrawerContent from './components/DrawerContent';
import { useClickOutside } from './hooks';
import { createDrawerStyles } from './styles';

interface UserSideBarProps {
     mobileOpen: boolean;
     desktopOpen: boolean;
     handleDrawerToggle: () => void;
}

const UserSideBar: React.FC<UserSideBarProps> = ({ mobileOpen, desktopOpen, handleDrawerToggle }) => {
     const { theme } = useThemeContext();
     const styles = createDrawerStyles(theme, 280);

     useClickOutside(desktopOpen, handleDrawerToggle);

     const drawerContent = <DrawerContent onClose={handleDrawerToggle} />;

     return (
          <Box
               component='nav'
               sx={{
                    width: { sm: desktopOpen ? 280 : 0 },
                    flexShrink: { sm: 0 },
                    transition: 'width 0.3s ease',
               }}
          >
               <Drawer
                    variant='temporary'
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    sx={{
                         display: { xs: 'block', sm: 'none' },
                         ...styles.drawer,
                    }}
               >
                    {drawerContent}
               </Drawer>

               <Drawer
                    variant='persistent'
                    open={desktopOpen}
                    sx={{
                         display: { xs: 'none', sm: 'block' },
                         ...styles.drawer,
                    }}
               >
                    {drawerContent}
               </Drawer>
          </Box>
     );
};

export default UserSideBar;
